import { gql } from "@apollo/client";

export const PRODUCT_QTY_SOLD_QUERY = gql`
  query GetProductQtySold($days: Int = 7) {
    getProductQtySold(days: $days) {
      dailyQty {
        date
        qty
        amount
      }
      totalQty
      percentageChange
    }
  }
`;
